const DURACION = 1400

function easeInOut(t: number): number {
  return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2
}

/** Desplaza la página hasta dejar el elemento centrado, con una animación lenta y suave. */
export function scrollSuaveHasta(id: string): void {
  const destino = document.getElementById(id)
  if (!destino) return

  const reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  const rect = destino.getBoundingClientRect()
  const objetivo = Math.max(
    0,
    window.scrollY + rect.top - (window.innerHeight - rect.height) / 2,
  )

  if (reducido) {
    window.scrollTo(0, objetivo)
    return
  }

  const inicio = window.scrollY
  const distancia = objetivo - inicio
  const t0 = performance.now()

  const paso = (ahora: number) => {
    const avance = Math.min((ahora - t0) / DURACION, 1)
    window.scrollTo(0, inicio + distancia * easeInOut(avance))
    if (avance < 1) requestAnimationFrame(paso)
  }

  requestAnimationFrame(paso)
}
